import { BrowserRouter } from "react-router-dom";
import Router from "./routes/router";
import { CustomThemeProvider } from "./theme/customThemeProvider";
import { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({ 
      duration: 500,
      easing: 'ease-in-sine',
      once: true
    });
  }, []);

  return (
    <CustomThemeProvider>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </CustomThemeProvider>
  );
}

export default App;